import apiClient from './api';

/**
 * As chamadas da foto de perfil, e a montagem da URL que o `<img>` usa.
 *
 * A URL é montada aqui — e não em cada `InitialsAvatar` — porque ela depende da origem da API: no
 * site é `/api/usuario/avatar/...`, relativo; no app nativo precisa ser absoluta
 * (`REACT_APP_API_BASE_URL`), senão a WebView procura a imagem no bundle local. O `apiClient` já
 * resolveu essa diferença uma vez, então a URL sai do `baseURL` dele em vez de repetir a decisão.
 *
 * O GET é público e sem token de propósito (um `<img src>` não manda Authorization); a autorização
 * é o próprio nome, um UUID que só circula em respostas da API e muda a cada troca.
 */

/** URL pública da foto, ou null sem nome. */
export function urlDoAvatar(nome) {
    if (!nome) return null;
    const base = String(apiClient.defaults.baseURL || '').replace(/\/+$/, '');
    return `${base}/usuario/avatar/${encodeURIComponent(nome)}`;
}

/**
 * Envia a foto já recortada (ver services/recorteImagem). Mesma chamada para o primeiro envio e
 * para a troca. Devolve o nome novo do arquivo — é ele que o cache do usuário logado e o estado da
 * tela precisam guardar.
 */
export async function enviarAvatar(blob) {
    const corpo = new FormData();
    corpo.append('arquivo', blob, 'avatar.jpg');

    // Sem Content-Type explícito: o navegador precisa montar o boundary do multipart sozinho, e
    // fixá-lo à mão produz um corpo que o backend não consegue separar.
    const { data } = await apiClient.post('/usuario/avatar', corpo);
    return data.avatar;
}

export async function removerAvatar() {
    await apiClient.delete('/usuario/avatar');
}
